import { PatientAllergyData } from '../../constants/api.config'
import getCharts from '../getCharts'

export default async function GetPatientAllergiesCRUD(mode, patientID = "-1", data = "", id = '-1', newDate = "",) {
    try {
        const payload = { mode, id, patientID, newDate, data }
        const res = await getCharts(PatientAllergyData, payload)
        return res.data
    } catch (error) {
        return error
    }
}
